module.exports = __webpack_public_path__ + "static/media/support-station-photo-02.4d58018e.jpg";